import { LazyLoadImage } from 'react-lazy-load-image-component';
import Skeleton from 'react-loading-skeleton';

import IconArrowLeft from '#app/UI/atoms/icons/arrowLeft';
import { useWindowSize } from '#hooks/index';

const NpsLogo = ({
  question,
  setQuestion,
  setComment,
  setScore,
  dataNPS,
  state,
  setStateScore
}) => {
  const { isMobile } = useWindowSize();
  const excludeQuestion = [1, 6];
  const isExcludable = excludeQuestion.includes(question);

  const prevQuestion = async question => {
    setQuestion(question);
    question === 1
      ? setScore(
          String(dataNPS.question1),
          setComment(dataNPS.optional1),
          setStateScore(!state.page1)
        )
      : question === 2
      ? setScore(
          String(dataNPS.question2),
          setComment(dataNPS.optional2),
          setStateScore(!state.page2)
        )
      : question === 3
      ? setScore(
          String(dataNPS.question3),
          setComment(dataNPS.optional3),
          setStateScore(!state.page3)
        )
      : question === 4
      ? setScore(
          String(dataNPS.question4),
          setComment(dataNPS.optional4),
          setStateScore(!state.page4)
        )
      : '';
  };

  return (
    <section className="nps-Wrapper">
      {isMobile && !isExcludable ? (
        <div
          className="nps-Wrapper__previous-question"
          onClick={() => prevQuestion(question - 1)}
        >
          <IconArrowLeft fill={'#000000'} />
        </div>
      ) : (
        ''
      )}
      {/* Logo */}
      <div
        className={
          isMobile && !isExcludable ? 'nps-Wrapper__logo-with-arrow' : 'nps-Wrapper__logo'
        }
      >
        <LazyLoadImage
          width={isMobile ? '186px' : '208px'}
          height={isMobile ? '10px' : '14px'}
          effect="blur"
          alt={'logo'}
          src={'../nps/logo/LogoCTC.svg'}
          placeholder={<Skeleton width="100%" height="100%" />}
        />
      </div>
    </section>
  );
};

export default NpsLogo;
